import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigColumnDef } from './config-table.component';

@Component({
  selector: 'app-config-billing-status',
  template: `<app-config-table
    tableName="Billing Statuses"
    [columns]="columns"
    permissionKey="Config.Billing.Manage"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate"
    [deleteFn]="delete">
  </app-config-table>`,
})
export class BillingStatusConfigComponent {
  columns: ConfigColumnDef[] = [
    { field: 'name',        label: 'Name',       type: 'text',     required: true, maxLength: 64 },
    { field: 'description', label: 'Description', type: 'textarea', maxLength: 255 },
    { field: 'sortOrder',   label: 'Sort Order',  type: 'number' },
  ];

  constructor(private http: HttpClient) {
    this.load       = () => this.http.get<any[]>('/api/config/billing-statuses');
    this.create     = (d: any) => this.http.post('/api/config/billing-statuses', d);
    this.update     = (id: any, d: any) => this.http.put(`/api/config/billing-statuses/${id}`, d);
    this.deactivate = (id: any) => this.http.delete<void>(`/api/config/billing-statuses/${id}`);
    this.delete     = (id: any) => this.http.delete<any>(`/api/config/billing-statuses/${id}/permanent`);
  }

  load!: () => Observable<any[]>;
  create!: (d: any) => Observable<any>;
  update!: (id: any, d: any) => Observable<any>;
  deactivate!: (id: any) => Observable<void>;
  delete!: (id: any) => Observable<any>;
}
